import { render, staticRenderFns } from "./ChangesChart.vue?vue&type=template&id=5a6ef00d&scoped=true&"
import script from "./ChangesChart.vue?vue&type=script&lang=js&"
export * from "./ChangesChart.vue?vue&type=script&lang=js&"
import style0 from "./ChangesChart.scss?vue&type=style&index=0&id=5a6ef00d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6ef00d",
  null
  
)

export default component.exports